module.exports = __webpack_public_path__ + "static/media/action_right.489aae99.png";